module.exports = __webpack_public_path__ + "static/img/popupclick.a3b968b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/popupclick.png
// module id = MNkb
// module chunks = 1